import styled, { css } from 'styled-components';
import SortIcon from 'mdi-react/SortVariantIcon';
import { Checkbox as CheckboxComponent, Radio } from '@prisjakt/ui-inputs';
import { layout, media } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';
import { SharedListItemStyles } from '@prisjakt/ui-dropdown-new/src/item';

export const SortOptions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: ${layout.spacing.medium};

  ${media.mediumDown`
    margin-right: auto;
  `};
`;

export const SortOptionsButton = styled(Button)`
  padding: 0;
`;

type ButtonTextProps = {
  hide?: boolean;
};

export const ButtonText = styled.span<ButtonTextProps>(
  props => css`
    ${props.hide &&
      css`
        display: none;
      `}
  `
);

export const SortIconComponent = styled(SortIcon)`
  margin-left: ${layout.spacing.xSmall};
`;

type RadioItemProps = {
  current: boolean;
};

export const RadioItem = styled(Radio)<RadioItemProps>(
  props => css`
    ${SharedListItemStyles};
    min-width: 140px;

    ${props.current &&
      css`
        font-weight: bold;
      `}
  `
);

export const Checkbox = styled(CheckboxComponent)`
  margin-left: ${layout.spacing.small};

  ${media.mediumDown`
    margin-left: auto;
    order: 3;
  `};
`;
